<input autocomplete="off" class="expert-mode-input"
      [ngStyle]="layoutPreferences?.noBorder ? {'border':'none'} : ''"
      [placeholder]="layoutPreferences?.placeholder || ''"
      [value]="expertQuery" (input)="updateQuery($event.target.value)" type="text" id="expertQueryInput">
